<script setup lang="ts">
/**
 * BG §19.3 — the metadata row. The portal is mostly ids, timestamps, costs and states, and this is how
 * they are presented: a mono uppercase key against a mono value, on a tabular grid so digits line up
 * down a column.
 */
withDefaults(defineProps<{ label: string; tone?: 'default' | 'system' | 'muted' }>(), { tone: 'default' })
</script>

<template>
    <div class="zh-key-value">
        <dt class="zh-key-value__key">{{ label }}</dt>
        <dd class="zh-key-value__value" :data-tone="tone"><slot /></dd>
    </div>
</template>

<style scoped>
.zh-key-value {
    display: grid;
    grid-template-columns: minmax(6rem, 10rem) 1fr;
    gap: 0.75rem;
    align-items: baseline;
    padding: 0.3125rem 0;
    border-bottom: 1px solid color-mix(in srgb, var(--dirty-white) 7%, transparent);
}

.zh-key-value:last-child {
    border-bottom: 0;
}

.zh-key-value__key {
    font-family: var(--font-mono);
    font-size: 0.6875rem;
    font-weight: 500;
    letter-spacing: var(--tracking-system);
    text-transform: uppercase;
    color: var(--muted-grey);
}

.zh-key-value__value {
    margin: 0;
    font-family: var(--font-mono);
    font-size: 0.8125rem;
    font-variant-numeric: tabular-nums;
    color: var(--dirty-white);
    /* Ids and URLs are long and must not push the panel wide. */
    overflow-wrap: anywhere;
}

.zh-key-value__value[data-tone='system'] {
    color: var(--electric-cyan);
}

.zh-key-value__value[data-tone='muted'] {
    color: var(--muted-grey);
}
</style>
